import widgetData from './widgetDataReducer';

const root = {
	widgetData
};

export default root;
